<template>
  <v-card elevation="5" outlined shaped class="bvt-outer">

    <!-- Barra superior (consistente con el resto de la app) -->
    <v-alert dense color="#EE680B" style="color:#ffffff; margin:0; border-radius:0;">
      <h5>BOLSA VIRTUAL DE TRABAJO</h5>
    </v-alert>

    <!-- Hero -->
    <div class="bvt-hero">
      <div class="bvt-deco bvt-deco-1"></div>
      <div class="bvt-deco bvt-deco-2"></div>
      <div class="bvt-deco bvt-deco-3"></div>

      <v-container class="bvt-hero-inner">
        <v-row align="center" justify="center">

          <!-- Columna de texto y beneficios -->
          <v-col cols="12" md="6" class="bvt-text-col">
            <div class="bvt-badge">
              <v-icon x-small color="#EE680B" class="mr-1">mdi-star-four-points</v-icon>
              Exclusivo para estudiantes UNICEN
            </div>

            <h1 class="bvt-title">
              Tu carrera<br>comienza aquí
            </h1>

            <p class="bvt-desc">
              Conectamos tu perfil universitario con las mejores oportunidades laborales del mercado boliviano.
            </p>

            <div class="bvt-benefits">
              <div class="bvt-benefit">
                <v-icon color="#EE680B" small>mdi-check-circle</v-icon>
                <span>Ofertas exclusivas para universitarios</span>
              </div>
              <div class="bvt-benefit">
                <v-icon color="#EE680B" small>mdi-check-circle</v-icon>
                <span>Empresas verificadas y confiables</span>
              </div>
              <div class="bvt-benefit">
                <v-icon color="#EE680B" small>mdi-check-circle</v-icon>
                <span>Tu historial académico como respaldo</span>
              </div>
            </div>
          </v-col>

          <!-- Tarjeta de login -->
          <v-col cols="12" sm="9" md="5">
            <v-card class="bvt-login-card" elevation="20" rounded="xl">

              <!-- Acento superior naranja -->
              <div class="bvt-card-accent"></div>

              <!-- Cabecera de la tarjeta -->
              <div class="bvt-card-head">
                <div class="bvt-icon-ring">
                  <v-icon size="34" color="#EE680B">mdi-briefcase-search-outline</v-icon>
                </div>
                <div class="bvt-card-head-title">Acceder a la Bolsa</div>
                <div class="bvt-card-head-sub">
                  Esta contraseña es la que usarás para ingresar a la Bolsa Virtual de Trabajo.
                  Si ya tienes cuenta, ingresa tu contraseña actual.
                </div>
              </div>

              <!-- Cuerpo del formulario -->
              <div class="bvt-card-body">
                <v-text-field
                  v-model="password"
                  label="Contraseña"
                  :type="mostrarPassword ? 'text' : 'password'"
                  :append-icon="mostrarPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="mostrarPassword = !mostrarPassword"
                  :rules="passwordRules"
                  outlined
                  dense
                  color="#EE680B"
                  hide-details="auto"
                  background-color="white"
                  @keyup.enter="acceder"
                />

                <button
                  class="bvt-btn"
                  :class="{ 'bvt-btn--disabled': !password || password.length < 8 || cargando }"
                  :disabled="!password || password.length < 8 || cargando"
                  @click="acceder"
                >
                  <v-progress-circular
                    v-if="cargando"
                    indeterminate
                    color="white"
                    size="20"
                    width="2"
                  />
                  <template v-else>
                    <v-icon color="white" small class="mr-2">mdi-login-variant</v-icon>
                    Ingresar a la Bolsa de Trabajo
                  </template>
                </button>
              </div>

            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </div>

    <!-- Snackbar de error -->
    <v-snackbar
      v-model="snackbarError"
      :timeout="4000"
      top right shaped dense
      color="red darken-2"
      outlined
    >
      <strong>{{ mensajeError }}</strong>
      <template v-slot:action="{ attrs }">
        <v-icon right v-bind="attrs" @click="snackbarError = false">mdi-close</v-icon>
      </template>
    </v-snackbar>

  </v-card>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      unicodigo: "",
      password: "",
      mostrarPassword: false,
      cargando: false,
      snackbarError: false,
      mensajeError: "",
      passwordRules: [
        v => (v && v.length >= 8) || 'La contraseña debe tener al menos 8 caracteres',
      ],
    };
  },
  created() {
    const user = JSON.parse(sessionStorage.getItem("session"));
    this.unicodigo = user.unico;
  },
  methods: {
    async acceder() {
      if (!this.password) return;
      this.cargando = true;
      try {
        const response = await axios.post(
          `/estudiante/registrarCandidatoBolsaVirtualDeTrabajo/${this.unicodigo}`,
          { password: this.password }
        );
        const redirectURL = `${process.env.VUE_APP_BVT_FRONTEND_URL}/external-auth?token=${response.data.token}`;
        window.location.href = redirectURL;
      } catch (error) {
        const status = error.response?.status;
        const msg = error.response?.data?.error;
        if (status === 401) {
          this.mensajeError = "Credenciales inválidas. Verifica tu contraseña.";
        } else if (status === 400) {
          this.mensajeError = msg || "Datos inválidos. Contacta a soporte.";
        } else {
          this.mensajeError = "Error al conectar con la bolsa de trabajo. Intenta más tarde.";
        }
        this.snackbarError = true;
      } finally {
        this.cargando = false;
        this.password = "";
      }
    },
  },
};
</script>

<style scoped>
/* ── Contenedor raíz ─────────────────────────────────── */
.bvt-outer {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 80vh;
  border-bottom: 4px solid #EE680B !important;
}

/* ── Hero ────────────────────────────────────────────── */
.bvt-hero {
  flex: 1;
  position: relative;
  overflow: hidden;
  background: #fbfbfb;
  display: flex;
  align-items: center;
  padding: 48px 0 56px;
}

/* Decoraciones sutiles para fondo claro */
.bvt-deco {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.bvt-deco-1 {
  width: 600px; height: 600px;
  background: radial-gradient(circle, #c8d8ed 0%, transparent 65%);
  opacity: 0.55;
  top: -220px; right: -180px;
}
.bvt-deco-2 {
  width: 350px; height: 350px;
  background: radial-gradient(circle, #dde6f0 0%, transparent 70%);
  opacity: 0.6;
  bottom: -120px; left: -90px;
}
.bvt-deco-3 {
  width: 200px; height: 200px;
  background: radial-gradient(circle, #EE680B 0%, transparent 70%);
  opacity: 0.06;
  top: 80px; left: 38%;
}

.bvt-hero-inner {
  position: relative;
  z-index: 1;
  width: 100%;
}

/* ── Texto izquierdo ─────────────────────────────────── */
.bvt-text-col { padding-bottom: 40px; }

@media (min-width: 960px) {
  .bvt-text-col { padding-bottom: 0; }
}

.bvt-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(238, 104, 11, 0.1);
  border: 1px solid rgba(238, 104, 11, 0.35);
  color: #c85500;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.bvt-title {
  color: #002245;
  font-size: clamp(1.9rem, 4vw, 2.7rem);
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 16px;
  letter-spacing: -0.5px;
}

.bvt-desc {
  color: #4a5d74;
  font-size: 0.95rem;
  line-height: 1.7;
  max-width: 380px;
  margin: 0 0 28px;
}

.bvt-benefits {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bvt-benefit {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #3a4f66;
  font-size: 0.88rem;
  font-weight: 500;
}

@media (max-width: 959px) {
  .bvt-title     { text-align: center; }
  .bvt-desc      { max-width: 100%; text-align: center; }
  .bvt-badge     { display: flex; justify-content: center; }
  .bvt-benefits  { align-items: center; }
}

/* ── Tarjeta de login ────────────────────────────────── */
.bvt-login-card {
  background: #ffffff;
  overflow: hidden;
  box-shadow:
    0 4px 6px rgba(0, 34, 69, 0.06),
    0 12px 40px rgba(0, 34, 69, 0.14) !important;
}

/* Franja naranja superior */
.bvt-card-accent {
  height: 5px;
  background: linear-gradient(90deg, #EE680B 0%, #ffaa33 100%);
}

.bvt-card-head {
  background: #ffffff;
  padding: 26px 28px 18px;
  text-align: center;
  border-bottom: 1px solid #edf0f4;
}

.bvt-icon-ring {
  width: 66px; height: 66px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fff4eb, #ffe4cc);
  border: 2px solid rgba(238, 104, 11, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  box-shadow: 0 4px 14px rgba(238, 104, 11, 0.18);
}

.bvt-card-head-title {
  color: #002245;
  font-size: 1.15rem;
  font-weight: 700;
}

.bvt-card-head-sub {
  color: #7a8fa6;
  font-size: 0.8rem;
  margin-top: 6px;
  line-height: 1.55;
}

.bvt-card-body {
  padding: 22px 28px 32px;
  background: #f9fafb;
}

/* ── Botón degradado ─────────────────────────────────── */
.bvt-btn {
  width: 100%;
  margin-top: 18px;
  padding: 13px 16px;
  background: linear-gradient(135deg, #EE680B 0%, #ff9a00 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-shadow: 0 4px 18px rgba(238, 104, 11, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.bvt-btn:hover:not(.bvt-btn--disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(238, 104, 11, 0.45);
}

.bvt-btn:active:not(.bvt-btn--disabled) {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(238, 104, 11, 0.3);
}

.bvt-btn--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>
